/** Local brand placeholder shown while media loads or when a URL fails. */
export const MEDIA_PLACEHOLDER = '/images/wonder-cement-placeholder.webp';
